import { User as BaseUser } from '@yoummday/ymmd-platform-core';

class BackofficeUser extends BaseUser {
	get isoCurrency() {
		// Default currency for the backoffice, this has to be set in the user object in the future. It doesn't suffice as the currency used in a talent's or financial documents context'.
		return this.user?.currency || 'EUR';
	}
}

const User = new BackofficeUser();
export { User };
